import React from 'react';

export function VersionBadge() {
  return (
    <div className="fixed bottom-2 right-2 z-50 opacity-30 hover:opacity-100 transition-opacity">
      <span className="text-[10px] font-mono text-primary bg-primary/10 px-1.5 py-0.5 rounded border border-primary/20">
        BETA v3.0
      </span>
    </div>
  );
}
